var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoSolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.063c4.61 0 8.438 3.789 8.438 8.437A8.427 8.427 0 0 1 10 18.938 8.402 8.402 0 0 1 1.562 10.5 8.427 8.427 0 0 1 10 2.062Zm0-1.25C4.648.813.312 5.188.312 10.5A9.686 9.686 0 0 0 10 20.188c5.313 0 9.688-4.336 9.688-9.688 0-5.313-4.375-9.688-9.688-9.688ZM8.594 14.25a.475.475 0 0 0-.469.469v.312c0 .274.195.469.469.469h2.812a.475.475 0 0 0 .469-.469v-.312a.504.504 0 0 0-.469-.469h-.469V8.781a.504.504 0 0 0-.468-.469H8.594a.475.475 0 0 0-.469.47v.312c0 .273.195.469.469.469h.469v4.687h-.47ZM10 4.875c-.703 0-1.25.586-1.25 1.25 0 .703.547 1.25 1.25 1.25.664 0 1.25-.547 1.25-1.25 0-.664-.586-1.25-1.25-1.25Z",
    fill: "#9496AC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoSolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-solid.f2c8d85c492bb2521190070bb7098ecd.svg";